import React, { createContext, useContext, useState, ReactNode } from 'react';
import en from './assets/lang/en.json';
import pt from './assets/lang/pt.json';

const translations: Record<Lang, { [key: string]: string }> = { en, pt };

export type Lang = 'en' | 'pt';

interface TranslationContextType {
  currLang: Lang;
  setCurrLang: (lang: Lang) => void;
  t: (key: string) => string;
}

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const useTranslation = () => {
    const context = useContext(TranslationContext);
    if (!context) {
        throw new Error('useTranslation must be used within TranslationProvider');
    }
    return context;
};

export const TranslationProvider = ({ children }: { children: ReactNode }) => {
    const [currLang, setCurrLang] = useState<Lang>('en');

    const t = (key: string) => {
        return translations[currLang][key] || key;
    }

    return (
        <TranslationContext.Provider value={{ currLang, setCurrLang, t }}>
            {children}
        </TranslationContext.Provider>
    );
};
